// Single source of truth for GST-retrofit related status gating.
// MUST stay in sync with the backend's POST_ORDER_STATUSES in
// MaterialDepotDjangoBackend/md/integration/zoho/services/document_transfer_service.py
// The backend rejects a GST retrofit for any status not in this list, so the
// frontend "write" gate must match it exactly.

// Statuses on which a GST retrofit (write) can be initiated.
export const GST_RETROFIT_STATUSES = [
  "order_placed",
  "order_confirmed",
  "payment_pending",
  "partly_shipped",
  "shipped",
  "partly_delivered",
  "delivered",
];

// Statuses on which the "View Zoho activity" panel (read-only) is offered.
// Superset of the retrofit statuses: an order can be retrofitted while e.g.
// "shipped" and later move to "dispatched", so we keep activity viewable there.
export const ZOHO_ACTIVITY_STATUSES = [...GST_RETROFIT_STATUSES, "dispatched"];

export const GST_RETROFIT_ALLOWED_PO_STATUSES = [
  "dispatch_pending",
  "dispatched",
  "delivered",
  "cancelled",
];

export const arePosGstRetrofitEligible = (
  pos?: Array<{ po_delivery_status?: string; is_deleted?: boolean; is_revised?: boolean }> | null,
): boolean =>
  (pos || [])
    .filter((po) => !po?.is_deleted && !po?.is_revised)
    .every((po) =>
      GST_RETROFIT_ALLOWED_PO_STATUSES.includes(po?.po_delivery_status || ""),
    );

export const isGstRetrofitStatus = (status?: string | null): boolean =>
  !!status && GST_RETROFIT_STATUSES.includes(status);

export const isZohoActivityStatus = (status?: string | null): boolean =>
  !!status && ZOHO_ACTIVITY_STATUSES.includes(status);
